import { render } from "./ClientOffering.vue?vue&type=template&id=0b581de5&scoped=true"
import script from "./ClientOffering.vue?vue&type=script&lang=js"
export * from "./ClientOffering.vue?vue&type=script&lang=js"

import "./ClientOffering.vue?vue&type=style&index=0&id=0b581de5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b581de5"]])

export default __exports__